import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { toLine, getImg, formatRGBA, getformatstruct } from '@/utils/utils';
import { mapState, mapGetters, mapMutations } from 'vuex';
import mappopupv2 from '@/components/mapv2/popupv2/index';
import pointlist from '@/view/map/hdmconfigv2/pointlist';
export default {
  name: 'mapmodule',
  emits: ['typeselect', 'close'],
  props: {
    id: {
      type: Number,
      default: 0
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    mapform: {
      type: Object,
      default: {}
    },
    style: {
      type: Object,
      default: {}
    },
    typelist: {
      type: Array,
      default: []
    },
    // 点位详情对象
    detail: {
      type: Object,
      default: {}
    },
    plist: {
      type: Array,
      default: []
    }
  },
  components: {
    mappopupv2,
    pointlist
  },
  meta: {
    title: ''
  },
  data() {
    return {
      query: '',
      indexdata: {
        bg: '',
        logo: '',
        pickey: '',
        golist: 'https://p.ananas.chaoxing.com/star3/origin/9e8f28b6ba59d0b1acd4393f6b133747.png'
      },
      modulestyle: {
        logo: '',
        pickey: '',
        type: '',
        list: {}
      },
      ctypeIndex: 0,
      typebtn: [],
      showtype: 1,
      popshowflag: false,
      // 控制弹窗显隐
      modeltype: 0,
      // 弹窗默认模板样式
      showgolist: false,
      showgolistId: 0,
      cform: {},
      // 非遗项目表单数据
      cformlabel: {},
      // 非遗项目表单结构标题集合
      cformoption: {},
      // 非遗项目表单结构默认选择项值集合
      cformfield: {},
      // 非遗项目表单校验集合
      cstructList: [],
      // 非遗项目表单结构数据
      cpList: [],
      // 添加或编辑非遗项目表单数据时列表
      defaultcform: {},
      // 非遗项目默认form数据
      formUserId: ''
    };
  },
  mounted() {
    this.query = this.$route.query;
    this.formUserId = this.query.formUserId;
  },
  computed: {
    ...mapGetters(['mapv2info'])
  },
  watch: {
    mapform: {
      handler(val) {
        if (val) {
          if (!this.isMobile) {
            this.indexdata.bg = val.background_img && val.background_img.length > 0 ? getImg(val.background_img[0]) : '';
          }
          if (this.isMobile) {
            this.indexdata.bg = val.app_bg_img && val.app_bg_img.length > 0 ? getImg(val.app_bg_img[0]) : '';
          }
          this.indexdata.logo = val.logo && val.logo.length > 0 ? getImg(val.logo[0]) : '';
          this.indexdata.pickey = val.pickey && val.pickey.length > 0 ? getImg(val.pickey[0]) : '';
          this.showtype = val.showtype;
          this.isHasallarea();
          if (val.cTemplateScore === 1) {
            this.getCulturalFormStruct();
          }
        }
      },
      deep: true
    },
    style: {
      handler(val) {
        console.log(`this.modulestyle`);
        this.modeltype = val.popStyleIndex === undefined ? 0 : val.popStyleIndex;
        Object.keys(this.modulestyle).forEach(key => {
          this.modulestyle[key] = this.posFormat(Object.keys(val).length > 0 ? {
            ...val[`${key}pos`]
          } : {
            ...this.mapv2info.style[`${key}pos`]
          });
        });
      },
      deep: true
    },
    'mapv2info.style': {
      handler(val) {
        if (val) {
          this.modeltype = val.popStyleIndex === undefined ? 0 : val.popStyleIndex;
          Object.keys(this.modulestyle).forEach(key => {
            this.modulestyle[key] = this.posFormat({
              ...val[`${key}pos`]
            });
          });
        }
      },
      deep: true
    },
    'style.typebtn': {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    'mapv2info.style.typebtn': {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    typelist: {
      handler(val) {
        // console.log(`mapmodulewatch`);
        // console.log(val);
      },
      deep: true
    },
    detail: {
      handler(val) {
        if (Object.keys(val).length > 0) {
          this.popshowflag = val[42] === '弹窗' && this.mapform.cTemplateScore === 0 ? true : false;
          if (this.mapform.cTemplateScore === 1) this.popshowflag = true;
        } else {
          this.popshowflag = false;
        }
      },
      deep: true
    },
    'style.popcolor'(val) {
      if (val) this.popcolorFormat(val);
    },
    'mapv2info.style.popcolor'(val) {
      if (val) this.popcolorFormat(val);
    }
  },
  methods: {
    /**
     * 定位点格式化
     */
    posFormat(val) {
      delete val.ptype;
      delete val.pIndex;
      return val;
    },
    /**
     * 分类数据格式化
     */
    typebtnFormat(val) {
      let typebtn = [...val];
      this.typebtn = [];
      typebtn.forEach(elem => {
        let item = {
          ...elem
        };
        if (item.imgList && item.imgList.length > 0) {
          item.backgroundImage = 'url(\'' + getImg(item.imgList[0]) + '\')';
          item.backgroundSize = '100% 100%';
          item.backgroundRepeat = 'no-repeat';
        }
        item.textAlign = 'center';
        delete item.imgList;
        let newitem = {};
        Object.keys(item).forEach(child => {
          newitem[toLine(child)] = item[child];
        });
        this.typebtn.push(newitem);
      });
    },
    popcolorFormat(val) {
      let obj = formatRGBA(val);
      let theme1 = `rgba(${obj.r},${obj.g},${obj.b},1)`;
      let theme2 = `rgba(${obj.r},${obj.g},${obj.b},0.7)`;
      document.documentElement.style.setProperty('--hand-drawn-pop-colortheme1', theme1);
      document.documentElement.style.setProperty('--hand-drawn-pop-colortheme07', theme2);
    },
    /**
     * 分类点击事件
     */
    typeClick(item, index) {
      this.ctypeIndex = index;
      this.$emit('typeselect', {
        index: index,
        item: item
      });
    },
    /**
     * 弹窗关闭事件
     */
    closeHandle() {
      this.popshowflag = false;
      this.$emit('close', true);
    },
    isHasallarea() {
      let that = this;
      let mapform = {
        deptId: this.query.fid,
        formId: '177623',
        page: 1,
        limit: 100,
        searchStr: {
          model: 0,
          filters: [{
            "model": 0,
            "filters": [{
              'alias': 'ishaschild',
              'compt': 'radiobutton',
              'express': '===',
              'val': ['是']
            }]
          }]
        }
      };
      mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
      this.$api.singleadvanceSearch(mapform).then(res => {
        console.log(`isHasallarea`);
        console.log(res);
        if (res.totalRow > 0) {
          this.showgolist = this.mapform.ishaschild === '是' ? false : true;
          if (this.showgolist) this.showgolistId = res.dataList[0].id;
        }
      });
    },
    golist() {
      let cquery = location.hash.split('?')[1];
      let cparams = cquery.split('&');
      cparams = cparams.map(item => {
        let itemarr = item.split('=');
        if (itemarr[0] === 'formUserId') {
          itemarr[1] = this.showgolistId;
          item = itemarr.join('=');
        }
        return item;
      });
      console.log(cparams);
      window.location.href = location.protocol + '//' + location.host + location.pathname + '?page=superMapv2?' + cparams.join('&');
    },
    /**
     * 获取非遗项目表单结构数据
     */
    getCulturalFormStruct() {
      let params = {
        deptId: this.query.fid,
        formId: 'cultural_heritage_project'
      };
      this.$api.formStruct(params).then(res => {
        this.cstructList = JSON.parse(JSON.stringify(res));
        this.cpList = getformatstruct(res, this.cform, this.cformlabel, this.cformfield, this.cformoption);
        this.defaultcform = Object.assign({}, this.cform);
        console.log(`获取非遗项目表单结构数据`);
        console.log(this.cform);
        console.log(this.cformoption);
      });
    }
  }
};